import { isBlank, isPresent } from 'helpers/string_helpers';
import { LABEL_MAP } from 'helpers/unit_helpers';
import { formatWithCommas } from 'helpers/formatters/number_formats';

export default class MeasurementFormatter {
  format(filterValue, options = {}) {
    if (isBlank(filterValue)) return '';
    if (!options.units) throw 'Option units is required';

    return `${formatWithCommas(filterValue)} ${LABEL_MAP[options.units] || options.units}`;
  }

  formatRange(filterMinValue, filterMaxValue, options = {}) {
    if (isBlank(filterMinValue) && isBlank(filterMaxValue)) return '';
    if (!options.units) throw 'Option units is required';

    if (isPresent(filterMinValue) && isPresent(filterMaxValue)) {
      const units = LABEL_MAP[options.units] || options.units;
      return `${formatWithCommas(filterMinValue)} - ${formatWithCommas(filterMaxValue)} ${units}`;
    } else if (isPresent(filterMinValue)) {
      return `≥ ${this.format(filterMinValue, options)}`;
    } else if (isPresent(filterMaxValue)) {
      return `≤ ${this.format(filterMaxValue, options)}`;
    } else {
      return '';
    }
  }
}
